import { render, staticRenderFns } from "./Reservas.vue?vue&type=template&id=413d7aba&scoped=true"
import script from "./Reservas.vue?vue&type=script&setup=true&lang=js"
export * from "./Reservas.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Reservas.vue?vue&type=style&index=0&id=413d7aba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413d7aba",
  null
  
)

export default component.exports